import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';

export const exroidEnquirySchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(1, 'Full name is required')
    .max(120, 'Full name is too long'),

  phone: z
    .string()
    .trim()
    .min(1, 'Phone number is required')
    .max(40, 'Phone number is too long'),

  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .email('Please enter a valid email')
    .max(160, 'Email is too long'),

  patientType: z.enum(['new-patient', 'existing-patient'], {
    message: 'Please select an option',
  }),

  message: z
    .string()
    .trim()
    .min(1, 'Message is required')
    .max(500, 'Message is too long'),
});

export type ExroidEnquiryValues = z.infer<typeof exroidEnquirySchema>;

export const exroidEnquiryDefaultValues: ExroidEnquiryValues = {
  fullName: '',
  phone: '',
  email: '',
  patientType: 'new-patient',
  message: '',
};

export const exroidEnquiryFields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'John Doe',
    required: true,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone',
    placeholder: '+44 000 000 00',
    required: true,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email',
    placeholder: 'johndoe@gmail.com',
    required: true,
    fullWidth: true,
  },
  {
    name: 'patientType',
    type: 'radio',
    label: 'You Are',
    required: true,
    options: [
      { label: 'New patient', value: 'new-patient' },
      { label: 'Existing patient', value: 'existing-patient' },
    ],
    fullWidth: true,
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message',
    placeholder: 'Enter the services you are interested in',
    required: true,
    rows: 5,
    maxLength: 500,
    fullWidth: true,
  },
];
